// basic prettyBytes to format bytes to human readable format
// implementation from `pretty-bytes` package
// @see: https://github.com/sindresorhus/pretty-bytes/blob/main/index.js#L66

const UNITS = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export const prettyBytes = (bytes: number) => {
	if (bytes === 0) {
		return `0 ${UNITS[0]}`;
	}

	const exponent = Math.min(Math.floor(Math.log10(bytes) / 3), UNITS.length - 1);
	const convertedBytes = bytes / 1000 ** exponent;
	const numberString = Number(convertedBytes.toPrecision(3)).toLocaleString();
	const unit = UNITS[exponent];

	return `${numberString} ${unit}`;
};
